module.exports = __webpack_public_path__ + "ups-logo.b69e843fd01965448dc07d784f996a52.svg";